import { render } from "./medicinal.vue?vue&type=template&id=2811b9b8&scoped=true"
import script from "./medicinal.vue?vue&type=script&lang=js"
export * from "./medicinal.vue?vue&type=script&lang=js"

import "./medicinal.vue?vue&type=style&index=0&id=2811b9b8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2811b9b8"]])

export default __exports__